

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { SystemAccessSetup } from "../../components/SystemAccessSetup";


export const SystemAccessSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="System Access"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "System Access", navigateTo: "/system-access" }
      ]}
      mainContents={<SystemAccessSetup />}
    />
  );
};
